interface GuidePreferences {
  dismissedGuides: string[];
}

const STORAGE_KEY = "timeTracker_guidePreferences";

class GuideService {
  private getPreferences(): GuidePreferences {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      try {
        return JSON.parse(stored);
      } catch (error) {
        console.error("Error parsing guide preferences:", error);
      }
    }
    return { dismissedGuides: [] };
  }

  private savePreferences(preferences: GuidePreferences): void {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(preferences));
    } catch (error) {
      console.error("Error saving guide preferences:", error);
    }
  }

  /**
   * Check if a specific guide should be shown
   * @param guideId - Unique identifier for the guide
   * @returns true if the guide should be shown, false if it has been dismissed
   */
  shouldShowGuide(guideId: string): boolean {
    const preferences = this.getPreferences();
    return !preferences.dismissedGuides.includes(guideId);
  }

  /**
   * Dismiss a guide permanently
   * @param guideId - Unique identifier for the guide to dismiss
   */
  dismissGuide(guideId: string): void {
    const preferences = this.getPreferences();
    if (!preferences.dismissedGuides.includes(guideId)) {
      preferences.dismissedGuides.push(guideId);
      this.savePreferences(preferences);
    }
  }

  /**
   * Reset all guide preferences (useful for testing or if user wants to see guides again)
   */
  resetPreferences(): void {
    this.savePreferences({ dismissedGuides: [] });
  }
}

export const guideService = new GuideService();
